import { Pencil } from 'lucide-react';
import type { Member } from '../../../types';
import { PlanIcon } from '../../shared';

export function MemberSummaryRow({
  member,
  expanded,
  onExpand,
}: {
  member: Member;
  expanded: boolean;
  onExpand: () => void;
}) {
  return (
    <div className='flex w-full items-center justify-between gap-2 bg-white py-4'>
      <div className='flex grow items-center gap-2'>
        <div className='size-[60px] shrink-0 lg:size-auto'>
          <PlanIcon plan={member.plan ?? 'Signature'} size='auto' />
        </div>
        <div className='flex grow flex-col items-start'>
          <div className='flex items-center gap-2'>
            <p className='font-sans text-[18px] leading-[130%] font-medium text-black'>
              {member.first_name} {member.last_name}
            </p>
          </div>
          <p className='font-sans text-[18px] leading-[130%] text-black'>
            {member.date_of_birth}
          </p>
          <p className='font-sans text-[18px] leading-[130%] text-black'>
            Sollis {member.plan}
          </p>
        </div>
      </div>
      {!expanded && (
        <button onClick={onExpand} className='cursor-pointer'>
          <span className='hidden font-sans text-[18px] leading-[130%] text-black underline lg:block'>
            Change Plan
          </span>
          <Pencil className='block h-6 w-6 text-black lg:hidden' />
        </button>
      )}
    </div>
  );
}
